module.exports = __webpack_public_path__ + "img/tp@2x.36c8fe5.webp";